import { Process } from '@attensi/api-js';

import { ReviewEnum, ProcessStats } from '../types/ProcessTypes';
// TODO Process Analyses only reviews the longest lengths,
// it does not take into account short milestones or hints

class ProcessAnalyser {

    getStats(process: Process): ProcessStats {
        const stats: ProcessStats = {
            totalNumberOfSteps: this._getTotalNumberOfSteps(process),
            longestHint: this._getLongestHint(process),
            longestMilestone: this._getLongetsMilestone(process),
            longestMilestoneTitle: this._getLongestMilestoneTitle(process),
            missingHints: this._getMissingHints(process),
        };

        return stats;
    }

    _getTotalNumberOfSteps(process: Process) {
        const totalNumberOfSteps = {
            length: 0,
            review: ReviewEnum.NONE,
        };
        totalNumberOfSteps.length = process.steps.length;
        totalNumberOfSteps.review = this._reviewTotalNumberOfSteps(totalNumberOfSteps.length);
        return totalNumberOfSteps;
    }

    _getLongestHint(process: Process) {
        const longestHint = {
            length: 0,
            index: 0,
            review: ReviewEnum.NONE,
        };

        for (const step of process.steps) {
            const hint = step.hint;
            if (hint) {
                if (hint.length > longestHint.length) {
                    longestHint.length = hint.length;
                    longestHint.index = step.index;
                }
            }
        }

        longestHint.review = this._reviewLongestHint(longestHint.length);
        return longestHint;
    }

    _getMissingHints(process: Process) {
        const hints: number[] = [];

        const missingHints = {
            hints,
            review: ReviewEnum.NONE,
        };

        for (const step of process.steps) {
            const hint = step.hint;
            if (hint === null || hint.length < 2) {
                missingHints.hints.push(step.index);
            }
        }
        if (missingHints.hints.length === 0) {
            missingHints.hints = [];
        }
        missingHints.review = this._reviewMissingHints(missingHints.hints);

        return missingHints;
    }

    _getLongetsMilestone(process: Process) {
        const longestMilestone = {
            length: 0,
            index: 0,
            review: ReviewEnum.NONE,
        };

        let i = 0;
        let n = 0;
        for (const step of process.steps) {
            if (step.milestone) {
                i = step.index;
                n = 1;
            } else {
                n++;
                if (n > longestMilestone.length) {
                    // TODO, this is not the milestone index, but the step index
                    longestMilestone.index = i;
                    longestMilestone.length = n;
                }
            }
        }
        longestMilestone.review = this._reviewLongestMilestone(longestMilestone.length);

        return longestMilestone;
    }

    _getLongestMilestoneTitle(process: Process) {
        const longestMilestoneTitle = {
            length: 0,
            index: 0,
            review: ReviewEnum.NONE,
        };

        for (const step of process.steps) {
            const milestone = step.milestone;
            if (milestone) {
                if (milestone.length > longestMilestoneTitle.length) {
                    longestMilestoneTitle.length = milestone.length;
                    longestMilestoneTitle.index = step.index;
                }
            }
        }
        longestMilestoneTitle.review = this._reviewLongestMilestoneTitle(longestMilestoneTitle.length);

        return longestMilestoneTitle;
    }


    _reviewLongestHint(length: number) {
        if (length > 100) {
            return ReviewEnum.BAD;
        }
        if (length > 80) {
            return ReviewEnum.OK;
        }
        return ReviewEnum.GOOD;
    }

    _reviewMissingHints(hints: number[]) {
        if (!hints) {
            return ReviewEnum.GOOD;
        }
        if (hints.length === 1) {
            return ReviewEnum.OK;
        }
        return ReviewEnum.BAD;
    }

    _reviewLongestMilestone(length: number) {
        if (length <= 1) {
            return ReviewEnum.BAD;
        }
        if (length < 3) {
            return ReviewEnum.OK;
        }
        if (length > 8) {
            return ReviewEnum.BAD;
        }
        if (length > 6) {
            return ReviewEnum.OK;
        }
        return ReviewEnum.GOOD;
    }

    _reviewLongestMilestoneTitle(length: number) {
        if (length > 80) {
            return ReviewEnum.BAD;
        }
        if (length > 60) {
            return ReviewEnum.OK;
        }
        return ReviewEnum.GOOD;
    }

    _reviewTotalNumberOfSteps(totalNumberOfSteps: number) {
        if (totalNumberOfSteps < 4) {
            return ReviewEnum.BAD;
        }
        if (totalNumberOfSteps < 6) {
            return ReviewEnum.OK;
        }
        if (totalNumberOfSteps > 16) {
            return ReviewEnum.BAD;
        }
        if (totalNumberOfSteps > 12) {
            return ReviewEnum.OK;
        }
        return ReviewEnum.GOOD;
    }
}

export { ProcessAnalyser };
